/**
 *
 */
class EventoLinks {
  /**
   *
   */
  constructor() {
    jQuery('[data-evento="1"]').each((index, item) => {
      this.setCorrectUrl(item);
    });
    jQuery('.Sticker__Link[data-evento="1"]').each((index, item) => {
      jQuery(item).parent().appendTo(jQuery('.StickerContainer'));
    });
    jQuery('.Sticker').each((index, item) => {
      this.addSizeClass(item);
    });

    this.updateLanguageNavigation();
  }

  updateLanguageNavigation() {
    const urlParams = new URLSearchParams(window.location.search);
    const eventId = urlParams.get('eventId');
    const cHash = urlParams.get('cHash');
    const htwEventoTagSection = urlParams.get('htwEventoTagSection');

    if (eventId || cHash || htwEventoTagSection) {
      jQuery('.LanguageNavigation li a').each((_, link) => {
        const $link = jQuery(link);
        const href = $link.attr('href');

        const linkParams = new URLSearchParams(
          href.includes('?') ? href.split('?')[1] : ''
        );

        if (eventId) {
          linkParams.set('eventId', eventId);
        }

        if (cHash) {
          linkParams.set('cHash', cHash);
        }

        if (htwEventoTagSection) {
          linkParams.set('htwEventoTagSection', htwEventoTagSection);
        }

        if (href.includes('?')) {
          $link.attr('href', href.split('?')[0] + '?' + linkParams.toString());
        } else {
          $link.attr('href', href + '?' + linkParams.toString());
        }
      });
    }
  }

  /**
   *
   * @param item
   */
  addSizeClass(item) {
    const $el = jQuery(item);
    const text = $el.text().trim();

    if (text.length > 20) {
      $el.addClass('Sticker__Medium');
    } else {
      $el.addClass('Sticker__Small');
    }
  }

  /**
   *
   * @param link
   */
  setCorrectUrl(link) {
    const $link = jQuery(link);
    const url = $link.attr('data-url');
    const param = $link.attr('data-param');

    const params = this.searchToParams(window.location.search);
    console.log(params);
    if (!params[param]) {
      $link.remove();
    }

    $link.attr(
      'href',
      url
        .replace(`:${param}`, params[param])
        .replace(`:${param}`, params[param])
    );
  }

  /**
   *
   * @param {String} search
   * @returns {{}}
   */
  searchToParams(search) {
    const [, parameterString] = search.split('?');

    if (!parameterString) return {};

    const parameters = parameterString.split('&').map((string) => {
      const [key, value] = string.split('=');
      return { key, value };
    });

    return parameters.reduce((prev, cur) => {
      prev[cur.key] = cur.value;
      return prev;
    }, {});
  }
}

export default EventoLinks;
